import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { RejectionsDto } from '.';

export class RejectionsResponseModel extends GlobalResponseObject{
    data?:RejectionsDto ;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //RejectionsDto
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?:RejectionsDto) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
